import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordModule } from 'primeng/password';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'kon-password-type',
  standalone: true,
  imports: [CommonModule, PasswordModule, ReactiveFormsModule],
  template: `
    <p-password
      [formControl]="$any(formControl)"
      [toggleMask]="true"
      [feedback]="false"
      [style]="{ width: '100%' }"
    ></p-password>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyPasswordTypeComponent extends FieldType<FormlyFieldConfig> {}
